import Header from './components/Header'
import { useEffect, useState } from 'react'
import classNames from 'classnames'
import GlobalState, { setLang } from './stores/GlobalState'
import { observer } from 'mobx-react'
import ContentState, {
  getBanners,
  getTrackingContent,
} from './stores/ContentState'
import Menu from './components/Menu'
import LocaleMenu from './components/LocaleMenu'
import TrackingContent from './components/TrackingContent'
import Cookie from './components/Cookie'
import { enMenu, ruMenu, ukrMenu } from './mocks/menu'
import { runInAction } from 'mobx'
import { enSubMenu, ruSubMenu, urkSubMenu } from './mocks/submenu'
import { useLocation } from 'react-router-dom'

const TrackingPage = observer(() => {
  const [loading, setLoading] = useState(true)
  const { pathname } = useLocation()
  useEffect(() => {
    if (pathname.includes('/en/') || pathname.includes('/uk/')) {
      localStorage.setItem(
        'lang',
        JSON.stringify({
          country: 'Ukraine',
          lang: 'English',
        }),
      )
    } else if (pathname.includes('/ru/')) {
      localStorage.setItem(
        'lang',
        JSON.stringify({
          country: 'Ukraine',
          lang: 'русский',
        }),
      )
    } else {
      localStorage.setItem(
        'lang',
        JSON.stringify({
          country: 'Ukraine',
          lang: 'Українська',
        }),
      )
    }
    setLang()
    getTrackingContent().then(() => {
      setTimeout(() => {
        setLoading(false)
      }, 200)
    })

    getBanners()

    return () => {
      setLoading(true)
    }
  }, [])

  useEffect(() => {
    const content = {
      uk:
        'Трекінг посилки - Відстеження пересування посилки по всьому світу ✔ Послуга відстеження посилки від компанії Nova Global',
      ru:
        'Трекинг посылки - Отслеживание передвижения посылки по всему миру ✔ Услуга отслеживания посылки от компании Nova Global',
      en:
        'Parcel tracking - Tracking the movement of a parcel around the world ✔ Parcel tracking service from Nova Global',
    }

    const titles = {
      uk: 'Трекінг посилки | Nova Global',
      ru: 'Трекинг посылки | Nova Global',
      en: 'Parcel tracking | Nova Global',
    }

    const title = GlobalState.currentLocale.lang.includes('En')
      ? titles.en
      : GlobalState.currentLocale.lang.includes('ру')
      ? titles.ru
      : titles.uk
    const cont = GlobalState.currentLocale.lang.includes('En')
      ? content.en
      : GlobalState.currentLocale.lang.includes('ру')
      ? content.ru
      : content.uk

    document
      .querySelector('meta[name="description"]')
      ?.setAttribute('content', cont)

    document.title = title
  }, [GlobalState.currentLocale])

  useEffect(() => {
    let menu: any = {},
      submenu: any = {}
    if (GlobalState.currentLocale.lang.includes('En')) {
      menu = enMenu
      submenu = enSubMenu
    } else if (GlobalState.currentLocale.lang.includes('ру')) {
      menu = ruMenu
      submenu = ruSubMenu
    } else {
      menu = ukrMenu
      submenu = urkSubMenu
    }

    runInAction(() => {
      ContentState.menu = menu
    })
    runInAction(() => {
      ContentState.subMenu = submenu
    })
  }, [GlobalState.currentLocale.lang])

  useEffect(() => {
    if (loading) return
    document.querySelector('#root')?.classList.add('visible')
    document.querySelector('#root')?.classList.add('auto')
    document.querySelector('html')?.classList.add('auto')
    document.querySelector('body')?.classList.add('auto')
    document.querySelector('.header')?.classList.remove('light')
    document.querySelector('.navigation')?.classList.remove('light')
    if (window.innerWidth <= 768) {
      ;(document.querySelector(
        '.button.chat',
      ) as HTMLElement)?.style.setProperty('visibility', 'hidden')
    }
    return () => {
      document.querySelector('#root')?.classList.remove('visible')
    }
  }, [loading])

  useEffect(() => {
    setTimeout(() => {
      window.addEventListener('scroll', (e) => {
        const header = document.querySelector('.header')

        if (!header) return
        if (window.scrollY > header?.getBoundingClientRect().height / 4) {
          header.classList.add('header-hidden')
        } else header.classList.remove('header-hidden')
      })
    }, 100)
  }, [])

  useEffect(() => {
    if (window.innerWidth >= 1024) {
      window.addEventListener('keydown', function (event: any) {
        const keyCode = event.which || event.keyCode
        var ctrl = event.ctrlKey
          ? event.ctrlKey
          : keyCode === 17 || event.metaKey
          ? true
          : false
        const codes = ['61', '107', '173', '109', '187', '189']
        if (ctrl && codes.includes(keyCode.toString())) {
          return false
        }

        if (keyCode != '86' && keyCode != '67' && ctrl && keyCode != 65) {
          return false
        }
      })
    }

    window.addEventListener('mousewheel DOMMouseScroll', function (event: any) {
      if (event.ctrlKey == true) {
        return false
      }
    })
  }, [])


  return (
    <>
      <Header />
      <Cookie />
      {!loading && (
        <div
          className={classNames(
            'container smooth-scroll',
            loading && 'hidden',
            !loading && 'visible',
            GlobalState.isLocaleOpen && 'overflow',
            GlobalState.isMenuOpen && 'overflow',
          )}
        >
          <TrackingContent />
        </div>
      )}
      <Menu />
      <LocaleMenu />
      <div
        className={classNames('menu__bg', GlobalState.isMenuOpen && 'show')}
      ></div>
      <div
        className={classNames('menu__bg', GlobalState.isLocaleOpen && 'show')}
      ></div>
    </>
  )
})

export default TrackingPage
